import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Feedback } from '../models/feedback';
import { map } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';

@Injectable({providedIn: 'root'})
export class FeedbackApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  async sendFeedback(data: any): Promise<Feedback> {
    return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/feedback/`, Feedback.toBack(data))
      .pipe(map(response => Feedback.toFront(response)))
      .toPromise();
  }

  async sendLeagueFeedback(leagueId: number, data: any): Promise<Feedback> {
    return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/feedback/`, Feedback.toBack(data))
      .pipe(map(response => Feedback.toFront(response)))
      .toPromise();
  }
}
